import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSiteContext } from "../../contexts/SiteProvider";
import { checkInterSection } from "../../services/core/FilterService";
import { get } from "../../services/smartApiService";
import { motion } from "framer-motion";
import "./sideBar.scss";

interface HeaderProps{
  isOpen:boolean
  setIsOpen: (open: boolean) => void;
}
const SmartHoverSideNav:React.FC<HeaderProps> = ({isOpen,setIsOpen}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSiteContext();
  const [tabData, setTabData] = useState([]);
  const loadTableData = () => {
    let URL = "/admin_menu/get_all_menu";
    const subscription = get(URL).subscribe((response) => {
      // console.log("links data ", response.data);
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);
  // console.log("logged in user ", user);
  const navigateLink = (index: any) => {
    if (index) {
      navigate("/" + index);
    }

    if (window.innerWidth <= 768) {
       setIsOpen(!isOpen);
    }
  };
  // const listItems: any[] = [
  //   {
  //     id: 1,
  //     label: "Dashboard",
  //     icon: "fa-tachometer",
  //     link: "employee/dashboard",
  //     roles: ["USER"],
  //   },
  //   {
  //     id: 1,
  //     label: "Leave",
  //     icon: "fa-ticket",
  //     link: "employee/leave-requests",
  //     roles: ["USER"],
  //   },
  //   {
  //     id: 1,
  //     label: "Attendance",
  //     icon: "fa-book",
  //     link: "employee/attendance-report",
  //     roles: ["USER"],
  //   },
  //   {
  //     id: 1,
  //     label: "Pay Slips",
  //     icon: "fa-industry",
  //     link: "employee/pay-slips",
  //     roles: ["USER"],
  //   },
  //   {
  //     id: 3,
  //     label: "Management",
  //     icon: "fa-book",
  //     // link: "hp/dashboard",
  //     roles: ["ADMIN"],
  //     children: [
  //       {
  //         id: 1,
  //         label: "Dashboard",
  //         icon: "fa-tachometer",
  //         link: "admin/dashboard",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Employees",
  //         icon: "fa-users",
  //         link: "employee/list-table",
  //         roles: ["ADMIN"],
  //       },
  //       // {
  //       //   id: 1,
  //       //   label: "Organization",
  //       //   icon: "fa-book",
  //       //   link: "admin/organization",
  //       //   roles: ["ADMIN"],
  //       // },
  //       {
  //         id: 1,
  //         label: "Leave Balances",
  //         icon: "fa-scale-balanced",
  //         link: "employee/leave-balances",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Employee salary",
  //         icon: "fa-hand-holding-dollar",
  //         link: "employee/employee-salary",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Leave Approval",
  //         icon: "fa-envelope-open",
  //         link: "employee/leave-approvals",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Attendance",
  //         icon: "fa-address-book",
  //         link: "employee/attendance-admin",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Pay Roll",
  //         icon: "fa-money-bill",
  //         link: "employee/salary-report",
  //         roles: ["ADMIN"],
  //       },
  //     ],
  //   },

  //   {
  //     id: 3,
  //     label: "Team Manager",
  //     icon: "fa-book",
  //     // link: "hp/dashboard",
  //     roles: ["IS_TEAM_MANAGER"],
  //     children: [
  //       {
  //         id: 1,
  //         label: "Leave Approval",
  //         icon: "fa-envelope-open",
  //         link: "employee/leave-approvals",
  //         roles: ["IS_TEAM_MANAGER"],
  //       },
  //       {
  //         id: 1,
  //         label: "Team Attendance",
  //         icon: "fa-address-book",
  //         link: "employee/attendance-admin",
  //         roles: ["IS_TEAM_MANAGER"],
  //       }, 
  //     ],
  //   },

  //   {
  //     id: 4,
  //     label: "Settings",
  //     icon: "fas fa-cogs",
  //     // link: "hp/dashboard",
  //     roles: ["ADMIN"],
  //     children: [
  //       {
  //         id: 1,
  //         label: "Assets",
  //         icon: "fa-address-card",
  //         link: "admin/assets",
  //         roles: ["ADMIN"],
  //       },
        
  //       {
  //         id: 1,
  //         label: "Role",
  //         icon: "fa-address-card",
  //         link: "admin/role-list",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Doc Check List",
  //         icon: "fa-user",
  //         link: "admin/check-list",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 14,
  //         label: "Designations",
  //         icon: "fa-users",
  //         link: "admin/designations",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 14,
  //         label: "Salary Components",
  //         icon: "fa-money-bill",
  //         link: "admin/salary-components",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 14,
  //         label: "Office Locations",
  //         icon: "fa-map-marker",
  //         link: "admin/locations",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 14,
  //         label: "Holidays",
  //         icon: "fa-tachometer",
  //         link: "admin/holidays",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 14,
  //         label: "Leave Types",
  //         icon: "fa-sign-out",
  //         link: "admin/leave_types",
  //         roles: ["ADMIN"],
  //       },  {
  //         id: 14,
  //         label: "Email Template",
  //         icon: "fa-envelope-o",
  //         link: "admin/email-template",
  //         roles: ["ADMIN"],
  //       }, 
  //       {
  //         id: 14,
  //         label: "Menu Settings",
  //         icon: "fa-book",
  //         link: "admin/menu-settings",
  //         roles: ["ADMIN"],
  //       },
  //       {
  //         id: 1,
  //         label: "Site Settings",
  //         icon: " fa-cog",
  //         link: "admin/site-settings",
  //         roles: ["ADMIN"],
  //       },
  //     ],
  //   },
  //   {
  //     id: 3,
  //     label: "Bills",
  //     icon: "fa-book",
  //     roles: ["USER", "ADMIN"],
  //     children: [
  //       {
  //         id: 1,
  //         label: "Submission",
  //         icon: "fa-rectangle-list",
  //         link: "admin/bill/submission",
  //         roles: ["USER", "ADMIN"],
  //       },
  //       {
  //         id: 2,
  //         label: "Approval",
  //         icon: "fa-thumbs-up",
  //         link: "admin/bill/approve",
  //         roles: ["USER", "ADMIN"],
  //       },
  //       {
  //         id: 3,
  //         label: "Accounts",
  //         icon: "fa-building-columns",
  //         link: "admin/bill/accounts",
  //         roles: ["USER", "ADMIN"],
  //       },
  //       // {
  //       //   id: 2,
  //       //   label: "Dashboard",
  //       //   icon: "fa-tachometer",
  //       //   link: "admin/dashboard",
  //       //   roles: ["USER", "ADMIN"],
  //       // },
  //     ],
  //   },
  // ];

  return (
    <ul>
      {tabData.map((item: any, index) => {
        let _roles = Array.isArray(item.roles)
          ? item.roles
          : item.roles.split(",");
        return (
          checkInterSection(user?.roles || [], _roles) && (
            <motion.li
              key={`nav_link_${index}`}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              onClick={() =>
                item.link.length > 1 ? navigateLink(item.link) : {}
              }
              className={
                location.pathname === item.link
                  ? "sidenav-link active-link"
                  : `sidenav-link ${!isOpen?"is-justify-content-center":""}`
              }
            >
              <div
                className={`is-flex ${!isOpen ? "is-flex-direction-column is-justify-content-center" : "is-flex-direction-row"} `}
                onClick={() =>
                  item.link.length > 1 ? navigateLink(item.link) : {}
                }
              >
                <div className="link-icon">
                  <i className={`icon fa ${item.icon} `}></i>
                </div>

                <span className="link-text">{item.label}</span>
            {!isOpen &&    <div className="link-open-label is-size-7">{item.label}</div>}
              </div>
          

              {item.children && (
                // <ul className="child-link">
                <motion.ul
                  className="child-link"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  {item.children.map((child: any,childIndex:number) => {
                    return (
                      checkInterSection(user?.roles || [], child.roles) && (
                        <>
                          <motion.li
                          key={`nav_link_${index}_${childIndex}`}
                          initial={{ opacity: 0, x: -10 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.2, delay: childIndex * 0.1 }}
                          className="sidenav-child-link-items">

                         
                        
                            <a
                              key={`nav_link_${index}`}
                              href="#"
                              onClick={() => navigateLink(child.link)}
                              // className={
                              //   location.pathname === child.link
                              //     ? "sidenav-child-link active-link"
                              //     : "sidenav-child-link "
                              // }
                            >
                              <span className="icon-text">
                                <span className="icon link-icon">
                                  <i className={`fa ${child.icon} `}></i>
                                </span>
                                <span className="link-text">{child.label}</span>
                              </span>
                            </a>
                            </motion.li>
                        </>
                      )
                    );
                  })}
                </motion.ul>
              )}
            </motion.li>
          )
        );
      })}
    </ul>
  );
};

export default SmartHoverSideNav;
